"use strict";
import {onFind} from "@elements/init-modules-in-scope";
import loadScript from "@elements/load-script";
import {find, findAll, on, toggleClass} from "@elements/dom-utils";

const selectors = {
    widgetId: '#aic-chat-widget-id',
    wrapperOverlay: '.aic-chat-widget__wrapper',
    button: '.aic-chat-widget__activate-button'
}
export function init () {
    let isMounted = false;
    let widgetInstance = null;

    onFind(".js-open-chat-link", function (chatLink) {
        console.log("[AI Concierge] load script")
        loadScript('https://concierge.goodguys.ai/aiconcierge_client_v2/chat-widget.umd.js').then(function () {
            console.log("[AI Concierge] script loaded, init icon")
            loadConcierge();

            onFind(selectors.button, function(button) {
                on('click', () => {
                    console.log("[AI Concierge] button clicked")

                    if(widgetInstance) {
                        console.log("[AI Concierge] widget instance available in button click. isMounted", isMounted)
                        isMounted ? toggleOverlayVisibility() : widgetInstance.mount();
                        isMounted = true;
                    }
                }, button)
            });
        })
    });

    function loadConcierge() {
        if(!ChatWidgetModule) {
            console.log("ChatWidgetModule not found");
            return;
        }

        widgetInstance = new ChatWidgetModule.ChatWidget({
            projectId: "6554cac3892c9d5bfdb43388",
            hideAvatar: true,
            onClose: () => {
                console.log("close function")
                toggleOverlayVisibility();
            }
        })
    }

    const toggleOverlayVisibility = () => {
        console.log("[AI Concierge] toggle overlay visibility");

        const overlay = find(selectors.widgetId);
        if(overlay) {
            toggleClass('aic-chat-widget--overlay-hidden', overlay);
        }
    }
}